/** Extrae el mensaje de error que devolvió la API sin castear a ciegas. */
export const apiErrorMessage = (error: unknown): string | undefined => {
  if (!error || typeof error !== "object" || !("response" in error)) {
    return undefined;
  }
  const { response } = error as { response?: unknown };
  if (!response || typeof response !== "object" || !("data" in response)) {
    return undefined;
  }
  const { data } = response as { data?: unknown };
  if (!data || typeof data !== "object" || !("error" in data)) return undefined;
  const { error: message } = data as { error?: unknown };
  return typeof message === "string" ? message : undefined;
};